module.exports = __webpack_public_path__ + "img/risk_manage_hi.18c092c5.png";